import { gql } from "@apollo/client";

export const organizationAppsFragment = gql`
    fragment OrganizationApps on AppInfo {
        appId
        orgId
        appIconUrl
        internalAppName
        prodLiveVersion
        appVendorUuidOptinFlag
        stagingLiveVersion
        platformType
        apiTokens {
            createdTsMillis
            stage
            token
        }
        versions {
            orgId
            appId
            appName
            appDescription
            version
            versionName
            reviewState
            features {
                featureScopeName
                enabled
            }
        }
        appAuthorizedOperations {
            authOperation
            authOperationTypes
        }
    }
`;
